export const types = {
    SCHEDULE: 'SCHEDULE',
    DELAY: 'DELAY'
};